type HttpMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

const route = (route: string, name: string, method: HttpMethod) => ({
  route,
  name,
  method,
});

export const genericRoutes = [
  route("login", "login", "POST"),
  route("/session/v2", "getSession", "POST"),
  route("/session/", "getSessionRestart", "POST"),
  route("/session/", "getSessionResume", "POST"),
  route("/session/", "getSessionFinalize", "PUT"),
  route("/session/", "getSessionReset", "PATCH"),
  route("/session/verify", "getSessionVerify", "GET"),
  route("/session/verify", "getSessionVerifyPn", "GET"),
  route("/session/reset/verify", "getSessionResetVerifyPn", "GET"),
  route("/sessionMessage/", "getSessionQuestions", "GET"),
  route("/sessionMessage", "getSessionMessage", "POST"),
  route("/sessionMessage/v2", "getSessionMessageV2", "POST"),
  route("/favorite", "getsessionFavoritePost", "POST"),
  route("/favorite", "getFavorite", "GET"),
  route("/favorite/", "getDesFavorite", "DELETE"),
  route("/sessionMetadata/", "getSessionMetadata", "GET"),
  route("/product/v2/autocomplete", "getProducts", "GET"),
  route("/product/naladi/", "editNaladi", "PUT"),
  route("/classifications", "getClassifications", "GET"),
  route("/classifications/", "getClassificationsId", "GET"),
  route("/classifications/pn/", "getClassificationsPn", "GET"),
  route("/classifications/", "classificationsTransfer", "PATCH"),
  route("/user/tax/eng-approvers", "getUserApprover", "GET"),
  route("/user/autocomplete", "getUserAutocomplete", "GET"),
  route("/user/tax/eng-approver/disable/", "getUserDelete", "PUT"),
  route("/user/tax/eng-approver/", "getPutEdit", "PUT"),
  route("/user/tax/eng-approver/info", "getUserEdit", "GET"),
  route("/classifications/approver", "getClassificationsTax", "GET"),
  route("/center/autocomplete", "getCenter", "GET"),
  route("/dashboard/classification", "getDashboard", "GET"),
  route("/classifications/approve/", "classificationsAprroverTax", "PUT"),
  route("/classifications/eng/approve/", "classificationsAprroverEng", "PUT"),
  route("/classifications/suspend/", "classificationsSuspend", "PUT"),
  route("/classificationMessage/", "ClassificationsMessage", "PUT"),
  route("/classificationMessage", "getClassificationsMessage", "POST"),
  route("/downloads/excel/", "getExcel", "GET"),
  route("/downloads/pdf/", "getPDF", "GET"),
  route("user/info", "getUserInfo", "GET"),
  route("/classification-history/", "getClassificationHistory", "GET"),
  route("/user/eng-approver/eng-internals", "getUserEngInternals", "GET"),
  route("/user/eng-approver/eng-internal/disable/", "getUserEngDelete", "PUT"),
  route("/user/eng-approver/crea", "getPutEditCreaEng", "PUT"),
  route("/user/eng-approver/eng-internals", "getPutUserEngInternals", "PUT"),
  route("/responsibility-groups", "getGroups", "GET"),
  route("/responsibility-groups", "createGroup", "POST"),
  route("/responsibility-groups/", "deleteGroup", "DELETE"),
  route("/responsibility-groups/", "getGroupRules", "GET"),
  route("/responsibility-groups/", "updateGroupRules", "PUT"),
  route("/responsibility-groups/", "getGroupParticipants", "GET"),
  route("/responsibility-groups/", "createGroupParticipant", "POST"),
  route("/responsibility-groups/", "deleteGroupParticipant", "DELETE"),
  route("/responsibility-groups/", "setGroupAdministrator", "PATCH"),
  route("/user/eng-admin/autocomplete", "getEngAdminAutocomplete", "GET"),
];

export async function buildUrl({
  route,
  params = [],
}: {
  route: string;
  params?: any[];
}) {
  const routePath = { ...genericRoutes.find((c) => c.name === route) };
  let routeReturn = routePath?.route;

  if (params.length > 0) {
    for (const param of params) {
      routeReturn = routeReturn?.replace(param.param, param.value);
    }
  }

  routePath.route = routeReturn;
  return routePath;
}
